(ns ycweb.app.admin.wholesale.clientorders.clientorder.tabs.order
  (:require
   [rum.core :as rum]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.config.order :as o.cfg]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.common :as co.t.cmn]
   [ycweb.app.admin.wholesale.clientorders.clientorder.common :as co.cmn]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.forms :as form]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc order-summary < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order-items-idx (cmn/curact process-atom :client-order/order.item-list)
        summary-input-data
        (map
          (fn [[_ coi]]
            {:variation/features (:variation/features coi)
             :line-item/qty (:client-order-item/qty coi)
             :line-item/price (:client-order-item/price-raw coi)
             :line-item/discount (:client-order-item/discount coi)
             :line-item/calc-vat (:client-order-item/calc-vat coi)})
          client-order-items-idx)]

    [:div
     (co.t.cmn/display-total-summary (co.t.cmn/summary-calculations summary-input-data))]))

(defmethod grid/action :admin.wholesale/client-order.order.item-list [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order-items (cmn/curact process-atom :client-order/order.item-list)
        client-order (cmn/curact process-atom :client-order)]

    (when (empty? client-order-items)
      (datatables/overlay app-atom :open o.cfg/order-items-table-name)
      (datatables/overlay app-atom :open o.cfg/order-additional-charges-table-name)
      (comms/send :admin.wholesale/client-order.order.item-list
        {:client-order/uuid (:client-order/uuid client-order)}))))

(defmethod comms/receive :admin.wholesale/client-order.order.item-list [app-atom {:keys [rows options]}]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)]
    (swap! process-atom assoc
      o.cfg/datasource-atom-path
      (yuc/index-by :client-order-item/id rows))
    (swap! action-atom assoc :variations (:variations options))
    (comms/send :admin.wholesale/client-order.item-info {:client-order/id (:client-order/id client-order)})
    (datatables/overlay app-atom :close o.cfg/order-items-table-name)
    (datatables/overlay app-atom :close o.cfg/order-additional-charges-table-name)
    (editor/post-comms app-atom o.cfg/order-items-editor-name {:options {:client-order-item/brand-id (:brands options)}})
    (editor/post-comms app-atom o.cfg/order-items-editor-name {:options {:client-order-item/variation-id (:variations options)}})
    (editor/post-comms app-atom o.cfg/order-additional-charges-editor-name {:options {:client-order-item/variation-id (:services options)}})))

(defmethod comms/receive :admin.wholesale/client-order.item-info [app-atom e]
  (let [action-atom (cmn/action-cursor app-atom)]
    (cond
      (yuc/presence (:stock/details e))
      (swap! action-atom assoc :client-order/stock-details (:stock/details e))

      (yuc/presence (:variation/details e))
      (swap! action-atom update-in
        [:client-order/stock-details :variation/details]
        merge (:variation/details e)))))

(defn status-update-button [app-atom client-order]
  (let [process-atom (cmn/process-cursor app-atom)
        dear-sync (cmn/curact process-atom :dear-sync/method)
        current-status (:client-order/status client-order)
        tags (map :name (cmn/curact process-atom :tags))
        back-ordered (some #{"Backorder"} tags)

        button-action
        (case current-status
          "Abandoned Cart"
          "Approve"

          "Order Placed"
          "Authorise"

          "Authorise")

        disabled?
        (cond
          (and
            (not back-ordered)
            (not (contains? #{"Abandoned Cart" "Order Placed"} current-status)))
          true

          (= dear-sync :push)
          false

          :else
          true)]

    [:div.flex-grid-group
     {:class (yuc/bem :flex-grid-group [:flush :align-left :valign-middle])}
     [:div.flex-grid-block
      {:class (yuc/bem :flex-grid-block [:fluid])}
      (buttons/button-web button-action
        (merge
          (urlstate/href-on-click
            #(grid/dispatch-action app-atom
               :admin.wholesale/client-order.order-status.check
               {:uuid (:client-order/uuid client-order)
                :action button-action}))
          {:style :primary
           :size :small
           :disabled disabled?}))]]))

(defn stock-modal [app-atom modal-type {:keys [title text items confirm-text confirm-key confirm-data feedback-type]}]
  (grid/open-modal app-atom modal-type
    (yuc/maybe assoc
      {:title title
       :text
       (cond
         feedback-type
         (feedback/feedback feedback-type
           [:b text]
           (when items
             [:div items]))

         :else
         text)}
      :cancel-text (when (= modal-type :grid/confirm) "Cancel")
      :confirm-text (when (= modal-type :grid/confirm) confirm-text)
      :confirm-key (when (= modal-type :grid/confirm) confirm-key)
      :confirm-data (when (= modal-type :grid/confirm) confirm-data))))

(rum/defc approve-order-modal-body < rum/reactive [app-atom modal-config-atom]
  (let [modal-config (rum/react modal-config-atom)
        config-data-atom (rum/cursor modal-config-atom :config-data)
        provisional-order-check (cmn/curact config-data-atom [:provisional :provisional-order-check])]

    [:div
     [:h3.u-text-center
      {:class (yuc/bem :heading [:medium-large])}
      (:title modal-config)]
     (:text modal-config)

     [:hr]
     [:div
      {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
      [:div
       {:class (yuc/bem :flex-grid-block [:m-2-6])}
       [:div.flex-grid-content
        (form/checkbox "Provisional?"
          (rum/cursor-in config-data-atom [:provisional :provisional-order-check])
          {:size :small
           :inline true
           :style {:height "100%"}
           :change-fn
           (fn [e]
             (when (false? provisional-order-check)
               (swap! app-atom update-in [:modal :config :config-data :provisional] dissoc :datetoship)))})]]

      [:div
       {:class (yuc/bem :flex-grid-block [:m-4-6])}
       [:div.flex-grid-content
        (datepicker/datepicker app-atom "Provisioned Date" "dd/mm/yyyy"
          [:modal :config :config-data :provisional :datetoship]
          {:size :small
           :datatype :date/dmy
           :disabled (not provisional-order-check)})]]]]))

(rum/defc approve-order-modal-footer < rum/reactive [app-atom modal-config-atom]
  (let [modal-config (rum/react modal-config-atom)]
    (grid/button-row
      {:left-text (or (:cancel-text modal-config) "Cancel")
       :left-no-icon true
       :left-fn #(grid/close-modal app-atom)
       :right-text (or (:save-text modal-config) "Submit")
       :right-no-icon true
       :right-fn
       #(do
          (grid/dispatch-action app-atom :admin.wholesale/client-order.order-status.update
            {:confirm-data (:config-data modal-config)})
          (grid/close-modal app-atom))})))

(defmethod grid/modal-config :admin.wholesale/approve-order [_ _ _]
  {:body approve-order-modal-body
   :footer approve-order-modal-footer
   :modal-type :alert})

(defmethod grid/action :admin.wholesale/client-order.order-status.check [app-atom {:keys [action] :as config} _]
  (let [process-atom (cmn/process-cursor app-atom)
        unsaved-changes (cmn/curact process-atom :unsaved-changes)
        items (vals (cmn/curact process-atom :client-order/order.item-list))
        dear-sync (cmn/curact process-atom :dear-sync/method)
        {:keys
         [all-items-count zero-stock-count partial-stock-count
          zero-stock-items partial-stock-items]}
        (co.cmn/check-stock-status items)]

    (cond
      (= dear-sync :pull)
      (stock-modal app-atom :grid/message
        {:title "Warning"
         :feedback-type :warning
         :text "The system is set to sync from Dear"
         :items [:p "The system is set to pull from Dear, Authorisation has been disabled."]})

      (not-empty unsaved-changes)
      (grid/dispatch-action app-atom :admin.wholesale/check.unsaved-changes
        {:unsaved-changes unsaved-changes
         :message "You have unsaved work, please save or discard the changes before proceeding"})

      (and
        (= action "Approve")
        (= all-items-count zero-stock-count)
        (pos? all-items-count))
      (stock-modal app-atom :grid/confirm
        {:title "Create Backorder"
         :text "No Stock Available"
         :feedback-type :warning
         :items
         [:div
          [:p "All items in this order have zero stock available."]
          (co.t.cmn/format-stock-items app-atom zero-stock-items "Items with no stock:")
          [:p "Would you like to create a backorder?"]]
         :confirm-text "Create Backorder"
         :confirm-key :admin.wholesale/client-order.order-status.update
         :confirm-data (assoc config :backorder? true)})

      (and
        (= action "Approve")
        (or (pos? zero-stock-count) (pos? partial-stock-count)))
      (stock-modal app-atom :grid/confirm
        {:title "Create Backorder"
         :text "Partial Stock Available"
         :feedback-type :warning
         :items
         [:div
          (when (pos? zero-stock-count)
            (co.t.cmn/format-stock-items app-atom zero-stock-items "Items with no stock:"))
          (when (pos? partial-stock-count)
            (co.t.cmn/format-stock-items app-atom partial-stock-items "Items with partial stock:"))
          [:div "Would you like to create a backorder?"]]
         :confirm-text "Create Backorder"
         :confirm-key :admin.wholesale/client-order.order-status.update
         :confirm-data (assoc config :backorder? true)})

      :else
      (let [action-text
            (case action
              "Approve"
              [:p
               "This will place the order and reserve the stock in the warehouse."
               [:br]
               [:b "The order will need to be authorised next in order to be fulfilled."]]
              "Authorise"
              [:p "The order will be fulfilled by the warehouse."])]
        (cond
          (= action "Approve")
          (grid/open-modal app-atom :admin.wholesale/approve-order
            {:title (str action " Order")
             :text action-text
             :multi-modal-type :variable
             :config-data config})

          :else
          (stock-modal app-atom :grid/confirm
            {:title (str action " Order")
             :text action-text
             :cancel-text "Cancel"
             :confirm-text "Confirm"
             :confirm-key :admin.wholesale/client-order.order-status.update
             :confirm-data config}))))))

(defmethod grid/action :admin.wholesale/client-order.order-status.update [app-atom modal-config _]
  (toaster/open-overlay app-atom :admin.wholesale/client-order.overview)
  (let [process-atom (cmn/process-cursor app-atom)
        form-fields (cmn/curact process-atom [:form :client-order])
        form-field-keys (keys form-fields)
        fields-with-errors (filter #(yuc/presence (get-in form-fields [% :error])) form-field-keys)
        {:keys [confirm-data]} modal-config]

    (when (not (empty? fields-with-errors))
      (swap! process-atom update-in [:form :client-order]
        (fn [form-fields]
          (reduce
            (fn [acc field-key]
              (update acc field-key dissoc :error))
            form-fields fields-with-errors))))
    (cond
      confirm-data
      (comms/send :admin.wholesale/client-order.order-status.update confirm-data)

      :else
      (toaster/open-toast app-atom :error "Config not set correctly" {}))))

(rum/defc display-list-item < rum/reactive [list-item]
  [:li list-item])

(defmethod comms/receive :admin.wholesale/client-order.order-status.update
  [app-atom {:keys [client-order tags wholesale-statuses errors msg error-msg field-errors]}]
  (toaster/close-overlay app-atom :admin.wholesale/client-order.overview)
  (when msg
    (toaster/open-toast app-atom :success msg {:closetime 4000}))
  (let [success (empty? errors)
        process-atom (cmn/process-cursor app-atom)]

    (cond
      field-errors
      (do
        (toaster/open-toast app-atom :error error-msg {:closetime 4000})
        (swap! process-atom update-in [:form :client-order] merge
          (w.cmn/overview-field-errors field-errors)))

      success
      (let [process-name (cmn/process-name app-atom)
            buttons (o.cfg/datatable-buttons app-atom o.cfg/order-items-editor-name)]
        (swap! app-atom update process-name
          (fn [process]
            (->
              process
              (assoc :wholesale-statuses wholesale-statuses :tags tags)
              (update :client-order merge client-order)
              (update-in [:form]
                (fn [form-entity]
                  (let [field-keys (keys client-order)]
                    (reduce
                      (fn [acc field-key]
                        (let [new-value (get client-order field-key)]
                          (cond
                            (get-in acc [:client-order field-key])
                            (update-in acc [:client-order field-key] assoc :value new-value)

                            :else
                            acc)))
                      form-entity field-keys)))))))
        (datatables/update-config app-atom o.cfg/order-items-table-name {:buttons buttons}))

      :else
      (grid/list-modal app-atom
        {:title "Unable to Authorise Order"
         :heading "Variation Errors"
         :list
         [:div
          {:style
           {:overflow-y :scroll}}
          (into [:ul]
            (map display-list-item errors))]}))))

(rum/defc display-order-items < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)]
    [:div
     [:div.u-margin-bottom-30
      {:class (yuc/bem :flex-grid-group [:valign-middle :align-left :flush])}
      [:div
       {:class (yuc/bem :flex-grid-block [:grow-yes :flush :fluid])}
       [:div.flex-grid-content
        (headings/heading "Order" {:type :h3 :size :default :flush true})]]
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        [:div
         {:class (yuc/bem :flex-grid-block [:fluid])}
         (status-update-button app-atom client-order)]]]
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        [:form
         {:name "client-order-download-form"
          :method "GET" :target "_blank"
          :action (str "/api/pdf/client-order/" (:client-order/uuid client-order))}
         (buttons/button-web "Download PDF"
           {:style :secondary
            :size :small
            :icon :download})]]]]
       [:div
        (datatables/table app-atom o.cfg/order-items-table-name o.cfg/order-items-table-fns)]
       [:div
        (headings/heading "Additional charges and services" {:type :h3 :size :small})
        (datatables/table app-atom o.cfg/order-additional-charges-table-name o.cfg/additional-charges-table-fns)]
       (order-summary app-atom)]))